import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LsqCommonModule } from '@lsq-frontend/common-ui';
import { FactoringDashboardComponent } from './factoring-dashboard.component';
import { DashboardAmountClusterComponent } from './dashboard-amount-cluster/dashboard-amount-cluster.component';
import { DashboardOverviewComponent } from './dashboard-overview/dashboard-overview.component';
import { RequestFundsComponent } from './request-funds/request-funds.component';
import { SupplyChainDirectCommonModule } from '../supply-chain/direct/supply-chain-direct-common.module';
import { FundRequestsComponent } from './fund-requests/fund-requests.component';
import { SummaryComponent } from './summary/summary.component';
import { AgingSummaryComponent } from './aging-summary/aging-summary.component';
import { CollectionsComponent } from './collections/collections.component';
import { LsqTablesModule } from '@lsq-frontend/common-ui';
import { PortfolioReportCardComponent } from './portfolio-report/portfolio-report-card.component';

@NgModule({
    declarations: [
        RequestFundsComponent,
        FactoringDashboardComponent,
        FundRequestsComponent,
        DashboardAmountClusterComponent,
        DashboardOverviewComponent,
        SummaryComponent,
        AgingSummaryComponent,
        CollectionsComponent,
        PortfolioReportCardComponent
    ],
    imports: [
        CommonModule,
        LsqCommonModule.forRoot(),
        SupplyChainDirectCommonModule,
        LsqTablesModule.forChild()
    ],
    exports: [
        RequestFundsComponent,
        FundRequestsComponent,
        FactoringDashboardComponent,
        DashboardAmountClusterComponent,
        DashboardOverviewComponent
    ]
})
export class FactoringDashboardModule {}
